import { defaultCheckListItems } from '../BankingCredito/ObservationChecklist/utils';

export const handleFormWithChecklist = (defaultForm, checklistItems) => {
  const checkListSelectedRefs =
    checklistItems?.map((item) => {
      const found = defaultCheckListItems.find((check) => check.id === item);
      return found?.refNegocioForm;
    }) || [];

  const formWithChecklist = defaultForm
    .filter((item) => !!item?.ref)
    .map((item) => {
      if (checkListSelectedRefs.includes(item?.ref)) {
        return {
          ...item,
          required: true,
          transparent: false,
          disabled: false,
        };
      } else {
        if (item?.ref === 'valor_parcelas') {
          return {
            ...item,
            readOnly: true,
          };
        }

        return {
          ...item,
          transparent: true,
          disabled: true,
        };
      }
    });

  return formWithChecklist;
};
